import { Component, Input, OnInit } from '@angular/core';

import { SendTypes } from '../../../core/api/models/send-types';
import { WhiteMessagesService } from './../../../core/api/services/white-messages.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'white-message-private-number-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class WhiteMessagePrivateNumberSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input() sendType?: SendTypes;

  constructor(protected currentService: WhiteMessagesService) {
    super();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'number';
    if (!this.label) this.label = 'common.privateNumber';
  }

  getItemsApi() {
    this.currentService
      .whiteMessagesGetWhiteMessagePrivateNumberForSend()
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
}
